import { AxiosResponse } from 'axios';

import { client, clientWithHttpResponse } from '@api/client';
import { URL } from '@api/urls';

import { TNameTitle } from '@interfaces/common/common';
import { IDefaultUploadUrlApi, IDownloadUrl } from '@interfaces/common/file';
import { IDefaultUploadUrlResponse } from '@interfaces/common/response';
import { ISaveImportRulesDTO, ISubmitFieldsMappingDTO } from '@interfaces/import/dto/importDTO';
import { ISystemFields } from '@interfaces/import/import';

const {
	createAssetUploadUrl,
	importTypes,
	assetSampleUrl,
	importAsset,
	importAssetGetAllFields,
	importAssetSaveImportRules,
	importAssetFieldSamples,
	importAssetSystemFields,
	importAssetFieldsMapping,
	importStatistics,
	importAssetExecute,
} = URL;

export const getUploadURL = ({ fileName }: IDefaultUploadUrlApi): Promise<IDefaultUploadUrlResponse> =>
	client.post(`/${createAssetUploadUrl}`, {
		fileName,
	});

export const getImportTypes = (): Promise<TNameTitle[]> => client.get(`/${importTypes}`);

export const runAllFields = (id: string): Promise<void> =>
	client.post(`${importAsset}${id}${importAssetGetAllFields}`, {});

export const getAllFields = (
	id: string,
): Promise<AxiosResponse> => {
	return clientWithHttpResponse.get(`${importAsset}${id}${importAssetGetAllFields}`);
};

export const getSampleUrl = (): Promise<IDownloadUrl> => client.get(`/${assetSampleUrl}`);

export const submitImportRules = ({
	id,
	skipEmptyFields,
	skipFields,
	importType,
}: ISaveImportRulesDTO): Promise<void> => {
	return client.post(`${importAsset}${id}${importAssetSaveImportRules}`, {
		skipEmptyFields,
		skipFields,
		importType,
	});
};

export const runFieldSamples = (
	id: string,
): Promise<void> => {
	return client.post(`${importAsset}${id}${importAssetFieldSamples}`, {});
};

export const getFieldSamples = (id: string): Promise<AxiosResponse> => {
	return clientWithHttpResponse.get(`${importAsset}${id}${importAssetFieldSamples}`);
};

export const getSystemFields = (): Promise<ISystemFields[]> => client.get(`${importAsset}${importAssetSystemFields}`);

export const submitFieldsMapping = ({
	id,
	fieldsMapping,
}: ISubmitFieldsMappingDTO): Promise<void> => {
	return client.post(`${importAsset}${id}${importAssetFieldsMapping}`, { fieldsMapping });
};

export const getImportStatistic = (id: string): Promise<AxiosResponse> => {
	return clientWithHttpResponse.get(`${importAsset}${id}${importStatistics}`);
};

export const runAssetsStatistics = (id: string): Promise<void> => {
	return client.post(`${importAsset}${id}${importStatistics}`, {});
};

export const approveImport = (id: string): Promise<void> => {
	return client.post(`${importAsset}${id}${importAssetExecute}`, {});
};
